export default __webpack_public_path__ + "static/media/aDeposit.bccdd775.svg";